import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";

import { isMobile } from "../../../common/parameters";
import { getScrollBarWidth } from "../../../common/helpers/getScrollBarWidth";

import { Container, Overlay, HorizontalAlign, VerticalAlign, Content, CloseButton } from "./styles";
import { IProps } from "./interfaces";

const Modal = ({ children, width, height, close, overflowHidden, minWidth, noBorderRadius, noScrollReturn: _noScrollReturn, withoutCloseOnClick }: IProps) => {
    const noScrollReturn = useRef(_noScrollReturn);
    const bodyScrollTop = useRef(getBodyScrollTop());
    const content = useRef<HTMLDivElement>(null);
    const handleModalClose = (e: KeyboardEvent) => {
        if (e.keyCode === 27 && close) {
            noScrollReturn.current = false;
            close();
        }
    };

    useEffect(() => {
        window.addEventListener("keyup", handleModalClose);
        let nav = document.getElementsByTagName("nav")[0];
        const scrollBarWidth = getScrollBarWidth()
        document.body.style.paddingRight = scrollBarWidth + "px";
        if (nav) {
            document.getElementsByTagName("nav")[0].style.paddingRight = scrollBarWidth + "px";
        };
        document.body.classList.add("modal-open");
        document.getElementsByTagName("body")[0].style.top = -bodyScrollTop.current + "px";
        window.scrollTo(0, 0);
        return () => {
            window.removeEventListener("keyup", handleModalClose);
            document.body.style.paddingRight = "";
            let nav = document.getElementsByTagName("nav")[0];
            if (nav) {
                document.getElementsByTagName("nav")[0].style.paddingRight = "";
            }
            document.getElementsByTagName("body")[0].style.top = "";
            document.body.classList.remove("modal-open");
            if (!noScrollReturn.current) {
                window.scrollTo(1, bodyScrollTop.current);
                setTimeout(() => {
                    window.scrollTo(0, bodyScrollTop.current);
                });
            }
        }
    }, []);

    
    const handleClose = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        if (withoutCloseOnClick) return;
        if (content.current!.contains(e.target as Node)) {
            return;
        }
        if (!isMobile && window.innerWidth - e.clientX <= 18) {
            // click on scrollbar
            return;
        }
        noScrollReturn.current = false;
        if (close) {
            close();
        }
    };
    if (!process.env.WEBPACK) return null;
    return ReactDOM.createPortal(
        <Container onMouseDown={handleClose} overflowHidden={!!overflowHidden}>
            <Overlay id="modal-scroll">
                <HorizontalAlign id="modal-scroll-content">
                    <VerticalAlign>
                        <Content
                            ref={content}
                            noBorderRadius={!!noBorderRadius}
                            style={{
                                width: width || "",
                                height: height || "",
                                minWidth,
                            }}
                        >
                            {close && (
                                <CloseButton
                                    onClick={() => {
                                        noScrollReturn.current = false;
                                        close();
                                    }}
                                >
                                    ×
                                </CloseButton>
                            )}
                            {children}
                        </Content>
                    </VerticalAlign>
                </HorizontalAlign>
            </Overlay>
        </Container>,
        document.getElementById("modal-root")!
    );
}

export default Modal;

const getBodyScrollTop = () => {
    const el = document.scrollingElement || document.documentElement;
    return el.scrollTop;
};
